// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAR3CxWUqmFvbAmoNE-2Oq0tzy-selwp0w',
  authDomain: 'qcrypt-558c1.firebaseapp.com',
  projectId: 'qcrypt-558c1',
  storageBucket: 'qcrypt-558c1.appspot.com',
  messagingSenderId: '934087058577',
  appId: '1:934087058577:web:35b61b62dd1c6a70e38b30',
  measurementId: 'G-HW1WWCEFDM',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-east4');
export default app;
